import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function DrawerListItem(props) {

  const {icon, title, path} = props
  const [currentMenu, setCurrentMenu] = React.useState(0);
  const navigate = useNavigate();

  const location = useLocation();

  React.useEffect(() => {   
    setCurrentMenu(location.pathname.split('/')[1])
  }, [location] );

  return (
    <ListItemButton
      selected={path === currentMenu}
      onClick={()=>{
        navigate(path, { replace: true })
      }}
      sx={{
        '& .MuiListItemIcon-root': {
          color: path === currentMenu ? 'primary.main' : 'text.primary',
        },'& .MuiListItemText-root':{
          color: path === currentMenu ? 'primary.main' : 'text.primary',
        }
      }}
    >
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText  primary={title} />
    </ListItemButton>
  );
}
